import { gql } from '@apollo/client';

const GET_FILTERS = gql`
  query {
    resourceFilters {
      name
      values {
        id
        value
        componentType
      }
    }
  }
`;

export default GET_FILTERS;
